<template>
  <TemplateTable
    :title="$t('menu.recom_sold-articles')"
    :text="$t('recom_sold_articles.description')"
    name="recomSoldArticles"
    :url="$listRoutes.recomSoldArticles"
    :table="newRecomSoldArticles"
    :filters="recomSoldArticlesFilters"
    :defaultFilters="defaultPaidAtFilter"
    :fields="fields"
    :requireFilters="true"
    :useCurrency="true"
    :filtersWording="filtersWording"
    scope="filters.soldArticles"
  />
</template>

<script>
import { mapState } from "vuex";
import TemplateTable from "@/components/templates/TemplateTable";

export default {
  name: "RecomSoldArticles",
  components: { TemplateTable },
  data() {
    return {
      loading: true,
      filtersWording: {
        paidAt: {
          filterTitle: this.$t('global.orderCreateAt')
        }
      },
      fields: [
        {
          key: "tradeIn.id",
          type: "eye",
          translationKey: "id",
          route: "recom_tradein-n-sell-article",
          size: "xs",
          query: { view: "sell" },
        },
        {
          key: "order.customer.email",
          type: "copy",
          size: "l",
          translationKey: "buyerEmail",
        },
        {
          key: "tradeIn.reference",
          translationKey: "articleId",
          size: "l",
          type: "tradeinItem",
          query: { view: "sell" },
        },
        { key: "tradeIn.ean", size: "l" },
        { key: "productName", size: "xxl" },
        { key: "tradeIn.sku", translationKey: "sku", size: "m" },
        { key: "state", type: "tagType", size: "m" },
        { key: "tradeIn.condition", type: "tagType", size: "m" },
        {
          key: "tradeIn.amountProposed",
          translationKey: "tradeInPrice",
          type: "formatPrice",
        },
        {
          key: "tradeIn.amountCredited",
          translationKey: "credit_price",
          size: "s",
          type: "formatPrice",
        },
        {
          key: "unitPrice",
          translationKey: "ttcSellPrice",
          type: "formatPrice",
        },
        {
          key: "order.customer.profile",
          type: "tagType",
          translationKey: "buyerProfil",
          size: "m",
        },
        {
          key: "order.reference",
          translationKey: "idOrder",
          size: "l",
          type: "recomOrderId",
        },
        {
          key: "order.paidAt",
          translationKey: "orderCreateAt",
          type: "date",
          size: "m",
        },
        {
          key: "shippingDate",
          translationKey: "shippingDate",
          type: "date",
          size: "m",
        },
        {
          key: "returnDate",
          translationKey: "returnDate",
          type: "date",
          size: "m",
        },
        {
          key: "refundDate",
          translationKey: "refundDate",
          type: "date",
          size: "m",
        },
        {
          key: "order.channel",
          translationKey: "canalVente",
          type: "tagType",
          size: "m",
        },
        { key: "order.shippingAddress.countryCode", size: "m" },
      ],
    };
  },
  computed: {
    ...mapState(["recomSoldArticles", "recomSoldArticlesFilters"]),
    defaultPaidAtFilter() {
      const date = new Date();
      date.setDate(date.getDate() - 30);
      return `paidAt[gte]=${date.toISOString().split('T')[0]}`;
    },
    newRecomSoldArticles() {
      if (this.recomSoldArticles?.items?.length) {
        return {
          ...this.recomSoldArticles,
          items: this.recomSoldArticles.items.map((item) => {
            return {
              ...item,
              sellingDate: item.order.payments?.[0]?.createdAt,
            };
          }),
        };
      } else {
        return null;
      }
    },
  },
  watch: {
    newRecomSoldArticles() {
      this.loading = false;
    },
  },
};
</script>
